import { connect } from 'react-redux';
import DemoModeBar from '../../../features/demoMode/reading/DemoModeHeader/DemoModeBar/DemoModeBar';
import { exitDemoMode, setDemoClass } from '../../../api/demoMode/reading/demoModeActions';
import { selectors } from '../../../root/reading/root';

const mapStateToProps = state => {
    return {
        isGuidedTourOn: selectors.getIsGuidedTourOn(state),
        demoClass: selectors.getDemoClass(state),
    };
};

const mapDispatchToProps = dispatch => ({
    exitDemoMode: () => {
        dispatch(exitDemoMode());
    },
    setDemoClass: demoClass => {
        dispatch(setDemoClass(demoClass));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(DemoModeBar);
